<template>
  <div class="row mt-5">
    <div class="col-12 mb-4">
      <nav class="portal_menu">
        <div class="nav nav-tabs" id="nav-tab" role="tablist">
          <router-link
              v-if="
                  currentUserRole === 'ROLE_ADMIN' ||
                  currentUserRole === 'ROLE_HEAD_OF_AMDL' ||
                  currentUserRole === 'ROLE_PRACTICE_MANAGER' ||
                  currentUserRole === 'ROLE_SITE_SUPPORT' ||
                  currentUserRole === 'ROLE_SITE_MANAGER'"
              :to="{ name: 'caseManagementCoachingInvitationToFirstAppointmentList', params: { id: coaching.id } }"
              :class="{ active: $route.name === 'caseManagementCoachingInvitationToFirstAppointmentList' }"
              class="nav-item nav-link"
              role="tab"
              aria-controls="nav-profile"
              aria-selected="false">
            Einladungsschreiben
          </router-link>

          <router-link
              :to="{ name: 'caseManagementCoachingFirstInterviewForm', params: { id: coaching.id } }"
              :class="{ active: $route.name === 'caseManagementCoachingFirstInterviewForm' }"
              class="nav-item nav-link"
              role="tab"
              aria-controls="nav-home"
              aria-selected="true">
            Erstgespräch
          </router-link>

          <router-link
              :to="{ name: 'caseManagementCoachingProtocolList', params: { id: coaching.id } }"
              class="nav-item nav-link"
              :class="{ active: $route.name === 'caseManagementCoachingProtocolList' }"
              aria-controls="nav-profile"
              aria-selected="false">
            Sitzungsprotokolle
          </router-link>

          <router-link
              :to="{ name: 'caseManagementCoachingFinalReportForm', params: { id: coaching.id } }"
              class="nav-item nav-link"
              :class="{ active: $route.name === 'caseManagementCoachingFinalReportForm' }"
              role="tab"
              aria-controls="nav-contact"
              aria-selected="false">
            Abschlussgespräch
          </router-link>

          <router-link
              :to="{ name: 'caseManagementCoachingConfirmationBillingForm', params: { id: coaching.id } }"
              class="nav-item nav-link"
              :class="{ active: $route.name === 'caseManagementCoachingConfirmationBillingForm' }"
              role="tab"
              aria-controls="nav-contact"
              aria-selected="false">
            Anwesenheitsliste
          </router-link>

          <router-link
              :to="{ name: 'caseManagementCoachingDocumentsForm', params: { id: coaching.id } }"
              class="nav-item nav-link"
              :class="{ active: $route.name === 'caseManagementCoachingDocumentsForm' }"
              role="tab"
              aria-controls="nav-contact"
              aria-selected="false">
            Dokumente
          </router-link>
        </div>
      </nav>
    </div>
  </div>

<!--  <div class="row mt-5">-->
<!--    <div class="col-12 mb-4">-->
<!--      <nav class="portal_menu">-->
<!--        <div class="nav nav-pills nav-tabs d-flex flex-column flex-md-row" id="nav-tab" role="tablist">-->

<!--          <router-link-->
<!--              v-if="['ROLE_ADMIN', 'ROLE_HEAD_OF_AMDL', 'ROLE_PRACTICE_MANAGER', 'ROLE_SITE_SUPPORT', 'ROLE_SITE_MANAGER'].includes(currentUserRole)"-->
<!--              :to="{ name: 'caseManagementCoachingInvitationToFirstAppointmentList', params: { id: coaching.id } }"-->
<!--              :class="{ active: $route.name === 'caseManagementCoachingInvitationToFirstAppointmentList' }"-->
<!--              class="nav-item nav-link mb-1 mb-md-0 mr-md-1"-->
<!--              role="tab">-->
<!--            Einladungsschreiben-->
<!--          </router-link>-->

<!--          <router-link-->
<!--              :to="{ name: 'caseManagementCoachingFirstInterviewForm', params: { id: coaching.id } }"-->
<!--              :class="{ active: $route.name === 'caseManagementCoachingFirstInterviewForm' }"-->
<!--              class="nav-item nav-link mb-1 mb-md-0 mr-md-1"-->
<!--              role="tab">-->
<!--            Erstgespräch-->
<!--          </router-link>-->

<!--          <router-link-->
<!--              :to="{ name: 'caseManagementCoachingProtocolList', params: { id: coaching.id } }"-->
<!--              class="nav-item nav-link mb-1 mb-md-0 mr-md-1"-->
<!--              :class="{ active: $route.name === 'caseManagementCoachingProtocolList' }"-->
<!--              role="tab">-->
<!--            Sitzungsprotokolle-->
<!--          </router-link>-->

<!--          <router-link-->
<!--              :to="{ name: 'caseManagementCoachingFinalReportForm', params: { id: coaching.id } }"-->
<!--              class="nav-item nav-link mb-1 mb-md-0 mr-md-1"-->
<!--              :class="{ active: $route.name === 'caseManagementCoachingFinalReportForm' }"-->
<!--              role="tab">-->
<!--            Abschlussgespräch-->
<!--          </router-link>-->

<!--          <router-link-->
<!--              :to="{ name: 'caseManagementCoachingConfirmationBillingForm', params: { id: coaching.id } }"-->
<!--              class="nav-item nav-link mb-1 mb-md-0"-->
<!--              :class="{ active: $route.name === 'caseManagementCoachingConfirmationBillingForm' }"-->
<!--              role="tab">-->
<!--            Anwesenheitsliste-->
<!--          </router-link>-->

<!--        </div>-->
<!--      </nav>-->
<!--    </div>-->
<!--  </div>-->
</template>

<script setup>
import { defineProps, toRefs } from 'vue';

const props = defineProps({
  coaching: {
    type: Object,
    required: true,
  },
  currentUser: {
    type: Object,
    required: true,
  },
});

const coaching           = toRefs(props)[ 'coaching' ];
const currentUser        = toRefs(props)[ 'currentUser' ];
const currentUserRole    = currentUser?.value?.roles[ 0 ];
const isDigitalSignature = coaching.value.digitalSignature;
</script>

<style scoped>

</style>